import React from "react";
import {CategoryIconMap, DestinationCategory} from "../../models/DestinationCategory";
import {getCategoryLabel, useTranslation} from "../../i18n/LanguageProvider";

interface Props {
  categories: DestinationCategory[];
}

const CategoryTagList: React.FC<Props> = ({ categories }) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-wrap gap-1.5">
      {categories.map((label, index) => (
        <div
          key={index}
          className="rounded-lg px-3 py-1.5 bg-[#F4F2FF] text-accent font-bold flex items-center text-[9px]"
        >
          {/* Icon */}
          <span className="mr-1">{CategoryIconMap[label]}</span>
          {/* Label */}
          <span>{getCategoryLabel(label, t)}</span>
        </div>
      ))}
    </div>
  );
};

export default CategoryTagList;
